// extracted by mini-css-extract-plugin
export var avatar = "_pw-3";
export var avatarContainer = "_pw-2";
export var avatarSpacer = "_pw-5";
export var avatarSpacerContainer = "_pw-4";
export var avatarStackContainer = "_pw-1";
export var bubble = "_pw-0";
export var remainderBubble = "_pw-6";